<template>
  <form class="p-2" @submit.prevent="handleAddDriver">
    <modal-container :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0">{{ $t("add-driver") }}</h4>
      </template>

      <template slot="body">
        <div class="form-group w-100">
          <label for="fullname"> {{ $t("driver-name") }}</label>
          <input
            type="text"
            name="name"
            v-model="name"
            class="form-control"
            required
            id="receiver-name"
            @keypress="isLetter($event)"
          />
        </div>
        <div class="form-group w-100">
          <label for="email"> {{ $t("email") }}</label>
          <input
            v-model="email"
            type="text"
            name="name"
            class="form-control"
            required
            id="email"
            :placeholder="$t('enter-mail')"
          />
        </div>
        <div class="form-group">
          <label for="InputNumber"> {{ $t("phone_num") }}</label>
          <input
            v-model="phoneNumber"
            type="tel"
            class="form-control"
            required
            id="phone-number"
            :placeholder="$t('enter-num')"
          />
          <!-- <p v-if="ErrorPhone" class="my-0 small text-error p-1">
            {{ ErrorPhone }}
          </p> -->
        </div>
        <div class="form-group">
          <label for="address"> {{ $t("address") }}</label>
          <input
            type="text"
            name="address"
            v-model="address"
            class="form-control"
            required
            :placeholder="$t('enter-address')"
          />
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("add") }}
          </button>
        </div>
      </template>
    </modal-container>
  </form>
</template>

<script>
import ModalContainer from "../../../components/ModalContainer.vue";

export default {
  name: "AddDriverModal",
  components: {
    ModalContainer,
  },
  props: {
    show: Boolean,
    onCancel: Function,
    items: Array,
    driver: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: this.driver?.name || "",
      email: this.driver?.email || "",
      phoneNumber: this.driver?.phoneNumber || "",
      address: this.driver?.address || "",
    };
  },
  methods: {
    handleAddDriver() {
      this.$emit("add-driver", {
        name: this.name,
        email: this.email,
        phoneNumber: this.phoneNumber,
        address: this.address,
      });
      this.onCancel();
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },
  },
  watch: {
    driver: {
      handler(newValues) {
        this.name = newValues.name || "";
        this.email = newValues.email || "";
        this.phoneNumber = newValues.phoneNumber || "";
        this.address = newValues.address || "";
      },
      deep: true,
    },
  },
};
</script>

<style></style>
